// ======================================================
// Created by: Halimunnisa
// Feature: Customer Acceptance Workflow
// Purpose: Provides a minimalist form for requesting Customer Acceptance status transitions, matching the Design Approval modal architecture.
// ======================================================
import React, { useState } from "react";
import { Card, FormTextarea, Button } from "../../../../components/ui";
import { SectionTitle } from "../../../../components/ui/Typography";

export const CustomerAcceptanceForm = ({
  initialData = {},
  onSubmit,
  onCancel,
  loading = false,
  hideActions = false,
  commonNotes,
  notesValue,
}) => {
  // ======================================================
  // Updated by: Halimunnisa
  // Feature: Customer Acceptance Workflow
  // Purpose: Removed Customer Acceptance status dropdown and aligned UI with Design Approval.
  // ======================================================
  const [formData, setFormData] = useState({
    notes: notesValue || ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    onSubmit({ ...formData, status: "Accepted" });
  };

  return (
    <Card padding="md" className="animate-in fade-in slide-in-from-bottom-2">
      {/* ======================================================
      Updated by: Halimunnisa
      Customer Acceptance workflow
      Reused Design Approval architecture
      ====================================================== */}
      <div className="space-y-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex flex-col">
            <SectionTitle>Customer Acceptance</SectionTitle>
          </div>
        </div>

        {/* ======================================================
        Updated by: Halimunnisa
        Feature: Customer Acceptance Workflow
        Purpose: Removed Customer Acceptance status dropdown and aligned UI with Design Approval.
        ====================================================== */}
        {/* Status Dropdown removed completely */}

        {commonNotes ? (
          commonNotes
        ) : (
          <FormTextarea
            label="Approval Notes"
            name="notes"
            placeholder="Any specific comments from the customer regarding the design..."
            value={formData.notes || ""}
            onChange={handleChange}
            rows={3}
            size="sm"
            labelClassName="label text-xs"
            inputClassName="input text-sm"
          />
        )}

        {!hideActions && (
          <div className="flex gap-3 pt-6 mt-6 border-t border-slate-50">
            <Button
              type="button"
              onClick={handleSubmit}
              loading={loading}
              //update Halimunnisa 09-06-2026
              //Aligned Customer Acceptance button styling with Design Approval for consistency across approval workflows. The button uses a solid dark background to signify the finality of the acceptance action, while the Cancel button is styled as a secondary action with a more subdued appearance.
              className="!bg-slate-900 hover:!bg-slate-800 !text-white !border-none flex-1 py-2.5 flex items-center justify-center gap-2 rounded-lg shadow-md"
            >
              Customer Accepted
            </Button>
            {onCancel && (
              <Button
                onClick={onCancel}
                variant="secondary"
                className="px-6 py-2.5 text-slate-600 border-slate-200 hover:bg-transparent hover:text-slate-800 focus:bg-transparent active:bg-transparent shadow-none"
              >
                Cancel
              </Button>
            )}
          </div>
        )}
      </div>
    </Card>
  );
};

export default CustomerAcceptanceForm;
